import type { Components } from '@mui/material/styles';
import { type Theme } from '@mui/material/styles';

export const stackTheme: Pick<Components<Theme>, 'MuiStack'> = {
  MuiStack: {
    defaultProps: {
      useFlexGap: true,
    },
  },
};
